export const baseURL = "https://metricinfoapi.betaphase.in";
export const oracleBaseURL = "https://apex.oracle.com";
